// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// configure Swiper to use modules
var heroSwiper = new Swiper(".heroSwiper", {
  direction: "horizontal",
  loop: false,

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var newsSwiper = new Swiper(".newsSwiper", {
  direction: "horizontal",
  loop: false,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    1: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 10,
    },
    991: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 60,
    },
  },
});
